export  function focus (el) {
  el.focus()
}